/**
 * Auto-generated file - do not edit by hand
 * Run `pnpm ui:generate:icons` to regenerate
 * Source: source/svg/search.svg
 */
import type { IconProps } from '../types';
const Search = ({ size, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="m20.335 20.333-5.287-5.286m1.953-4.714a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0"
    />
  </svg>
);
export default Search;
